<template>
  <div>
    <TableActionHeader
      @filterChange="onFilterChange"
      :selectOptions="statusOptions"
      :selected="statusFilter"
      @filterSelect="onFilterSelect"
      @newItem="onNewItem"
      :newButton="$UIPrivilegeC('devices/ssedisplays')"
    >
    </TableActionHeader>

    <b-table
      ref="table"
      responsive="sm"
      striped
      hover
      selectable
      select-mode="single"
      @row-selected="onRowSelected"
      :items="displayList"
      :fields="fields"
      :small="true"
      :no-provider-paging="true"
      :no-provider-filtering="true"
      :per-page="perPage"
      :current-page="currentPage"
      :filter="filter"
      @filtered="onFiltered"
      :sort-compare="sortCompare"
    >
      <template v-slot:cell(status)="data">
        <b-icon
          v-if="data.value == 'ONLINE'"
          icon="check-square-fill"
          scale="2"
          variant="success"
          v-b-tooltip.hover.right="$t('sse_displays.states.ONLINE')"
        ></b-icon>
        <b-icon
          v-if="data.value == 'OFFLINE'"
          icon="exclamation-square-fill"
          scale="2"
          variant="danger"
          v-b-tooltip.hover.right="$t('sse_displays.states.OFFLINE')"
        ></b-icon>
        <b-icon
          v-if="data.value == 'UNKNOWN'"
          icon="question-square-fill"
          scale="2"
          variant="secondary"
          v-b-tooltip.hover.right="$t('sse_displays.states.UNKNOWN')"
        ></b-icon>
      </template>
      <template v-slot:cell(timetable)="data">
        <router-link
          :to="{
            path: '/content/timetables',
            query: { id: data.item.configuration.timetable_view_id },
          }"
          >{{ data.item.configuration.timetable_view_id }}</router-link
        >
      </template>
      <template v-slot:cell(presentationState)="data">
        <b-container class="m-0 p-0 pr-3">
          <b-iconstack
            v-if="data.value === 'normal'"
            class="float-right"
            v-b-tooltip.hover.right="
              $t('sse_displays.presentationStateValues.normal')
            "
          >
            <b-icon stacked icon="display" scale="2"></b-icon>
            <b-icon
              stacked
              icon="check-square-fill"
              variant="success"
              scale="1.1"
              shift-v="-10"
              shift-h="10"
            ></b-icon>
          </b-iconstack>
          <b-iconstack
            v-if="data.value === 'blank'"
            class="float-right"
            v-b-tooltip.hover.right="
              $t('sse_displays.presentationStateValues.blank')
            "
          >
            <b-icon stacked icon="display" scale="2"></b-icon>
            <b-icon
              stacked
              icon="dash-square-fill"
              variant="warning"
              scale="1.1"
              shift-v="-10"
              shift-h="10"
            ></b-icon>
          </b-iconstack>
          <b-iconstack
            v-if="data.value === 'only_announcements'"
            class="float-right"
            v-b-tooltip.hover.right="
              $t('sse_displays.presentationStateValues.only_announcements')
            "
          >
            <b-icon stacked icon="display" scale="2"></b-icon>
            <b-icon
              stacked
              icon="info-square-fill"
              variant="info"
              scale="1.1"
              shift-v="-9"
              shift-h="10"
            ></b-icon>
          </b-iconstack>
        </b-container>
      </template>
    </b-table>

    <TablePagination
      :total-rows="totalRows"
      :per-page="perPage"
      @pageChange="onPageChange"
    >
    </TablePagination>
  </div>
</template>

<script>
import sseDisplay from '@/store/displays/sseDisplay'

export default {
  props: ['item'],
  components: {},
  data: function () {
    return {
      perPage: 15,
      currentPage: 1,
      filteredRows: 1,
      filteredDisplays: [],
      statusOptions: [
        { id: 'ALL', label: this.$t('sse_displays.states.ALL'), icon: 'list' },
        {
          id: 'ONLINE',
          label: this.$t('sse_displays.states.ONLINE'),
          icon: 'check-square-fill',
          variant: 'success',
        },
        {
          id: 'OFFLINE',
          label: this.$t('sse_displays.states.OFFLINE'),
          icon: 'exclamation-square-fill',
          variant: 'danger',
        },
        {
          id: 'UNKNOWN',
          label: this.$t('sse_displays.states.UNKNOWN'),
          icon: 'question-square-fill',
          variant: 'secondary',
        },
      ],
      filter: '',
      statusFilter: 'ALL',
    }
  },
  watch: {
    statusFilter() {
      this.currentPage = 1
    },
    item() {
      if (!this.item) this.$refs.table.clearSelected()
    },
  },
  computed: {
    displayList() {
      var displays = this.$store.state.sseDisplay.sseDisplayList
      if (this.statusFilter != 'ALL') {
        var filtered = []
        const self = this
        displays.forEach(function (display) {
          if (self.statusFilter == self.getDisplayState(display))
            filtered.push(display)
        })
        displays = filtered
      }
      return displays
    },
    fields() {
      return [
        {
          key: 'status',
          label: this.$t('sse_displays.status'),
          tdClass: 'statusCellClass',
          formatter: 'getState',
          sortable: true,
        },
        {
          key: 'uniqueId',
          label: this.$t('sse_displays.uniqueid'),
          sortable: true,
        },
        { key: 'name', label: this.$t('sse_displays.name'), sortable: true },
        { key: 'timetable', label: this.$t('sse_displays.views') },
        {
          key: 'presentationState',
          label: 'State',
          formatter: (value, key, item) => {
            const attribute = item.attributes.find(
              (attr) => attr.name === 'presentation_state'
            )
            const presentationState = attribute ? attribute.value : ''
            return `${presentationState}`
          },
          sortable: true,
        },
      ]
    },
    totalRows() {
      if (!this.filter) {
        return this.displayList.length
      }
      return this.filteredRows
    },
    screenshots() {
      return this.$store.state.sseDisplay.screenshots
    },
  },
  beforeCreate: function () {
    if (!this.$store.state.sseDisplay) {
      this.$store.registerModule('sseDisplay', sseDisplay)
    }
    this.$store.dispatch('sseDisplay/getDisplayList')
  },
  created() {
    if(this.$route.query.uniqueId) {
      var item = this.$route.query.uniqueId;
      this.filter = item;
    }
    if(this.$route.query.displayId) {
      var displayId = this.$route.query.displayId;
      this.onFilterChange(displayId);
    }
    
    var status = this.$route.query.status
    if (status) this.statusFilter = status.toUpperCase()
  },
  methods: {
    onNewItem() {
      this.$emit('newItem')
    },
    onFilterChange(filter) {
      this.filter = filter
    },
    onFilterSelect(id) {
      this.statusFilter = id
    },
    onSelectDisplay(item) {
      this.$store.commit('sseDisplay/changeSelectedDisplay', item)
      this.$emit('selectItem', item)
    },
    onPageChange(page) {
      this.currentPage = page
    },
    onFiltered(filteredItems) {
      this.filteredRows = filteredItems.length
      this.currentPage = 1
      this.filteredDisplays = filteredItems
    },
    updateScreenshot(identifier) {
      this.$store.dispatch('sseDisplay/getScreenshot', identifier)
    },
    onRowSelected(items) {
      if (items[0]) this.$emit('selectItem', items[0])
    },
    statusCellClass(value, key, item) {
      var cellClass = 'status ' + this.getState(value, key, item)
      return cellClass
    },
    getState(value, key, item) {
      return this.getDisplayState(item)
    },
    getDisplayState(item) {
      /*
            var state = "UNKNOWN";
            if (item.status.timestamp) {
                var now = new Date();
                var sd = Date.parse(item.status.timestamp);
                var limit = 1000 * 60 * 10; //  10 min
                state = (now - sd < limit) ? "ONLINE" : "OFFLINE";
            }
            return state;*/
      return item.onlineStatus
    },
    sortCompare(a, b, key) {
      if (typeof a[key] === 'number' && typeof b[key] === 'number') {
        // If both compared fields are native numbers
        return a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0
      } else if (key === 'presentationState') {
        const aAttribute = a.attributes.find(
          (attr) => attr.name === 'presentation_state'
        )
        const bAttribute = b.attributes.find(
          (attr) => attr.name === 'presentation_state'
        )
        const aState = aAttribute ? aAttribute.value : ''
        const bState = bAttribute ? bAttribute.value : ''

        return aState.toString().localeCompare(bState.toString(), undefined, {
          numeric: true,
        })
      } else {
        return a[key].toString().localeCompare(b[key].toString(), undefined, {
          numeric: true,
        })
      }
    },
    sendScreenCaptureRequest() {
      // console.log({
      //   'this.filter': this.filter,
      //   'this.filteredDisplays': this.filteredDisplays,
      //   'this.displayList': this.displayList,
      // })
      const currDeviceIds = []
      if (this.filter.length === 0 && this.filteredDisplays.length === 0) {
        // console.log('Current devices:', this.displayList)
        this.displayList.forEach((device) =>
          currDeviceIds.push(device.deviceId)
        )
      } else {
        // console.log('Current filtered out devices:', this.filteredDisplays)
        this.filteredDisplays.forEach((device) =>
          currDeviceIds.push(device.deviceId)
        )
      }
      // console.log('currDeviceIds', currDeviceIds)
      this.$store.dispatch('sseDisplay/sendCaptureRequest', currDeviceIds)
    },
  },
}
</script>
